export default __webpack_public_path__ + "static/media/eye.5de31159.svg";